module.exports = __webpack_public_path__ + "static/media/icon.a1813104.svg";